import { useTranslation } from 'next-i18next'

type ProgressBarProps = {
  progress: number
  stars: number
}

const ProgressBar = ({ progress, stars }: ProgressBarProps) => {
  const { t } = useTranslation()
  return (
    <div className="py-3">
      <div className="w-full bg-brand-grayD9 rounded-full h-2 ">
        <div
          className="bg-brand h-2 rounded-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <div className="text-brand-gray text-xs flex justify-between mt-1 font-medium">
        <span>
          {stars} {t('text-stars')}
        </span>
        <span>{progress}%</span>
      </div>
    </div>
  )
}

export default ProgressBar
